module.exports = __webpack_public_path__ + "media/images/circle-b7b550ec.svg";